import GraphRanges from "@/mixins/GraphRanges";
import { Patient } from "@/store/modules/patient/types";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

const patientNamespace = { namespace: "patient" };
@Component({})
export default class Sirs extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  get charts(): MultiChartConfig[] {
    return [
      {
        data: this.graph(["SIRS"]),
        suggestedMax: 4
      }
    ];
  }

  get scores() {
    const [
      pfRatio,
      GCS,
      Bilirubin,
      platelet,
      cr,
      cardio
    ] = this.current.body.atoms.sofa.legend
      .split(",")
      .map((index: string) => parseInt(index, 10));
    return { pfRatio, GCS, Bilirubin, platelet, cr, cardio };
  }

  get pfRatio() {
    const text = this.current.body.atoms.pafi.legend;
    const index = this.scores.pfRatio;
    return { text, index };
  }

  get GCS() {
    const text = this.current.body.current.GCS.value;
    const index = this.scores.GCS;
    return { text, index };
  }
  get Bilirubin() {
    const text = this.current.body.current.Bilirubin.value;
    const index = this.scores.Bilirubin;
    return { text, index };
  }

  get platelet() {
    const text = this.current.body.atoms.platelet.legend.replace("|", " ");
    const index = this.scores.platelet;
    return { text, index };
  }

  get cr() {
    const text =
      this.current.body.atoms.cr.value +
      ", " +
      Math.round(this.current.body.atoms.urine24.value) +
      " ml";
    const index = this.scores.cr;
    return { text, index };
  }

  get cardio() {
    const text = "";
    const index = this.scores.cardio;
    return { text, index };
  }

  created() {
    this.selectedTime = 24;
  }
}
